import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import TermsAndConditionsModal from 'scenes/V2/TermsAndConditionsModal';
import { update } from 'redux/ducks/User';

// Mounted once at the app root (see src/index.js) so the updated Terms block
// every authenticated route rather than the dashboard alone — otherwise
// deep-linking straight to any other route skips the modal entirely.
//
// The modal is always rendered and toggled via isOpen, never conditionally
// mounted: it locks body scroll while open and only releases it when it
// re-renders closed, so unmounting it instead would leave the page unscrollable
// after accepting.
export const TermsAndConditionsGate = ({ authenticated, user, updateUser, history, location }) => {
  // currentUser defaults to {} while logged out, so an authenticated session
  // with a real user is required — otherwise this would open over the login,
  // sign-up and marketing pages.
  //
  // Scoped to EventOperators: they are the payers, the updated Terms carry
  // ACH billing language that is meaningless for other roles, and the rollout
  // task only clears tc_accepted for them. Without this an Admin, Parent,
  // Patient or AT with a falsy tc_accepted would be blocked out of every route
  // by a modal written for someone else.
  const isOpen =
    !!authenticated &&
    !!user.id &&
    user.type === 'EventOperator' &&
    !user.termsAndConditions &&
    location.pathname !== '/logout';

  return (
    <TermsAndConditionsModal
      isOpen={isOpen}
      user={user}
      updateUser={updateUser}
      history={history}
    />
  );
};

const mapStateToProps = state => ({
  authenticated: state.session.authenticated,
  user: state.session.currentUser,
});

const mapDispatchToProps = dispatch => ({
  updateUser: user => dispatch(update(user)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TermsAndConditionsGate));
